import React, { useState, useEffect } from "react";
import TopNav from "../TopNav/TopNav";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import watch from "../../Assets/newAsset/lpassets/Watch.webp";
import fasting from "../../Assets/newAsset/lpassets/fasting.webp";
import folder from "../../Assets/newAsset/lpassets/folder.webp";
import testTube from "../../Assets/newAsset/lpassets/testTubes.webp";
import homeCar from "../../Assets/newAsset/lpassets/homeCar.svg";
import ImagingDetailAccordion from "./ImagingDetailAccordion";
import stars from "../../Assets/newAsset/stars.svg";
import Content from "../../Pages/homePage/Components/Content";
import LpForm from "../../Pages/packageDetailsPage/LpForm";
import Featured from "../../Pages/homePage/Components/Featured";
import Tool1 from "../../Assets/newAsset/plandetails/docTool1.svg";
import Tool2 from "../../Assets/newAsset/plandetails/tool2.svg";

import step1 from "../../Assets/newAsset/lpassets/newAssets/step1.webp";
import step2 from "../../Assets/newAsset/lpassets/newAssets/step2.webp";
import step3 from "../../Assets/newAsset/lpassets/newAssets/step3.webp";
import step4 from "../../Assets/newAsset/lpassets/newAssets/step4.webp";
import step5 from "../../Assets/newAsset/lpassets/newAssets/step5.webp";
import Tool3 from "../../Assets/newAsset/plandetails/tool3.svg";
import { Link } from "react-scroll";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import BookForm from "./BookForm";
import { AiFillInfoCircle } from "react-icons/ai";
import { AddtoCart, getCartDetails } from "../../Redux/Actions";
import TestParameter from "./TestParameter";
import { Helmet } from "react-helmet";

//plandetail
const dataforPlan = [
  {
    id: 1,
    img: Tool1,
    question: "Who all are eligible for the test?",
    answer: "",
  },
  {
    id: 2,
    img: Tool2,
    question: "Why take this test?",
    answer: "",
  },
  {
    id: 3,
    img: Tool3,
    question: "What are the benefits of this test?",
    answer: "",
  },
];

//test parameter accordion
const dataforTest = [
  {
    id: 1,
    img: "",
    question: "Complete Hemogram (24 Tests)",
    answer: "",
  },
  {
    id: 2,
    img: "",
    question: "Liver Function Tests (12 Tests)",
    answer: "",
  },
  {
    id: 3,
    img: "",
    question: "Urine Routine & Microscopy (21 Tests)",
    answer: "",
  },
];

//QNA
const QNAaRRAY = [
  {
    question: "Who all are eligible for this test?",
    answer:
      "Kidney function test is a simple process that uses the blood or urine samples to help analyze the problems in kidneys.",
  },
  {
    question: "Who all are eligible for this test?",
    answer:
      "Kidney function test is a simple process that uses the blood or urine samples to help analyze the problems in kidneys.",
  },
  {
    question: "Who all are eligible for this test?",
    answer:
      "Kidney function test is a simple process that uses the blood or urine samples to help analyze the problems in kidneys.",
  },
];
///EXPORT COMPONENT STARTS
export const Warning = ({ desc }) => {
  return (
    <div className="parentWarDiv">
      <div className="warning">
        <AiFillInfoCircle />
        <span>{desc}</span>
      </div>
    </div>
  );
};

export const Regards = () => {
  return (
    <div className="parentWarDiv">
      <div className="noWar">
        <img
          src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/1d439d3b-60b8-4660-a56c-2fbde90e20fa.svg"
          alt="https://staticcdn.redcliffelabs.com/media/gallary-file/None/1d439d3b-60b8-4660-a56c-2fbde90e20fa.sv"
        />
        {/* <span>FREE E-Report will be sent to your registered email ID</span> */}
      </div>
    </div>
  );
};
//EXPORT COMPONENT ENDS
function ImagingPlanComponent({
  packageDetails,
  QNA,
  btmQna,
  testPara,
  citySel,
}) {
  console.log("packDetails ==>", packageDetails);
  const [intro, setIntro] = useState(true);
  const [param, setparam] = useState(false);
  const [crieteria, setCrieteria] = useState(false);
  const [QNAactive, seQna] = useState(false);
  const [details, setDetails] = useState(false);
  const history = useHistory();
  const dispatch = useDispatch();
  //GETTING RESPONSE FROM STORE
  const cartStatus = useSelector((state) => state.addToCartReducer);

  const setIntroActive = () => {
    setIntro(true);
    setparam(false);
    setCrieteria(false);
    seQna(false);
    setDetails(false);
  };

  const paramsActive = () => {
    setIntro(false);
    setparam(true);
    setCrieteria(false);
    seQna(false);
    setDetails(false);
  };

  const setCrieteriaActive = () => {
    setIntro(false);
    setparam(false);
    setCrieteria(true);
    seQna(false);
    setDetails(false);
  };

  const setQna = () => {
    setIntro(false);
    setparam(false);
    setCrieteria(false);
    seQna(true);
    setDetails(false);
  };

  const setDetailsActive = () => {
    setIntro(false);
    setparam(false);
    setCrieteria(false);
    seQna(false);
    setDetails(true);
  };

  const Mrp = packageDetails?.package_center_address_prices?.package_price
    ? packageDetails?.package_center_address_prices?.package_price
    : packageDetails?.package_price;
  const offerPrice = packageDetails?.package_center_address_prices?.offer_price
    ? packageDetails?.package_center_address_prices?.offer_price
    : packageDetails?.offer_price;
  const discount = Mrp - offerPrice;
  const finalPrice = Mrp - discount;

  console.log(Mrp, offerPrice, "MRP HERE");
  var discountPrice = 0;

  const discountPercentage = Math.ceil((discount / Mrp) * 100);

  const successCb = () => {
    const userFromLocal = JSON.parse(localStorage.getItem("user"));
    const CenterAddress = JSON.parse(localStorage.getItem("hospAddr"));

    var token = userFromLocal.token;
    if (CenterAddress) {
      dispatch(getCartDetails(token, citySel, CenterAddress?.id));
    }
  };

  const addtocart = (packageid) => {
    const userFromLocal = JSON.parse(localStorage.getItem("user"));
    var token = userFromLocal && userFromLocal.token;

    const body = {
      package: packageid,
    };

    if (token && token !== "" && token) {
      dispatch(AddtoCart(body, token, successCb));
    } else {
      history.push({
        pathname: "/login",
        pushToUrl: "imaging/cart",
      });
    }
  };

  const Centeraddress = useSelector(
    (state) => state.setImgCenterAddressReducer?.CenterAddress
  );

  console.log(Centeraddress, "<<<<<<");

  useEffect(() => {
    dispatch({
      type: "EPMTY_CART_OBJECT",
    });
  }, []);
  const [cartButton, setButton] = useState("Add to cart");

  useEffect(() => {
    if (cartStatus && cartStatus.cart && cartStatus.cart !== "") {
      if (cartStatus?.loading == true) {
        console.log("CART ADD STATUS", cartStatus.loading);
        setButton("Adding");
      } else {
        setButton("Added");
      }
    } else {
      setButton("Add to Cart");
    }
  }, [cartStatus, cartStatus && cartStatus.loading]);

  const [offset, setOffset] = useState(-180);
  useEffect(() => {
    window && window.screen && window.screen.width;
    if (window && window.screen && window.screen.width < 780) {
      setOffset(-140);
    }
  });

  const handleCentreNameClick = (slug, city) => {
    if (slug && city) {
      history.push(`/${city}/imaging/${slug}`);
    }else{
      console.log(slug,"Slug",city ,"city")
    }
  };

  return (
    <>
      <div className="main_plancomponent comp2 imagingDetail">
        <div className="plancomponentContent comp1">
          <div className="upperSection">
            <div className="leftside_section">
              <div id="packageHeading" className="reverseView">
                <h1 className="headingPink headtop headingBlack">
                  {packageDetails.name}
                  {citySel ? ` in ${citySel}` : null}
                </h1>

                {/* {packageDetails.parameter > 1 ? (
                  <p>
                    Includes:
                    <span className="cardInfo_mainHeading">
                      {" "}
                      {packageDetails.parameter} tests
                    </span>
                  </p>
                ) : (
                  <p>
                    Includes:
                    <span className="cardInfo_mainHeading">
                      {" "}
                      {packageDetails.parameter} test
                    </span>
                  </p>
                )} */}

                {/* <p>{packageDetails.description}</p> */}
              </div>
              <ul className="selectNav">
                <div className="nav-list">
                  <li className="navListItem firstLiItem">
                    <Link
                      onClick={setIntroActive}
                      className={
                        intro && intro
                          ? "navListItem currentSelected"
                          : "navListItem"
                      }
                      to="packageHeading"
                      offset={offset}
                      smooth={true}
                      duration={0}
                    >
                      Introduction
                    </Link>
                  </li>
                  {packageDetails.description !== "" &&
                  packageDetails.description !== null ? (
                    <li className="navListItem">
                      <Link
                        onClick={setCrieteriaActive}
                        className={
                          details
                            ? "navListItem currentSelected"
                            : "navListItem "
                        }
                        to="details"
                        offset={offset}
                        smooth={true}
                        duration={0}
                      >
                        Test Details
                      </Link>
                    </li>
                  ) : null}
                  {QNA && QNA?.length && QNA?.length !== 0 ? (
                    <li className="navListItem">
                      <Link
                        onClick={setCrieteriaActive}
                        className={
                          crieteria
                            ? "navListItem currentSelected"
                            : "navListItem "
                        }
                        to="criteria"
                        offset={offset}
                        smooth={true}
                        duration={0}
                      >
                        Test Criteria
                      </Link>
                    </li>
                  ) : null}
                  <li className="navListItem">
                    {testPara && testPara?.length && testPara?.length !== 0 ? (
                      <Link
                        onClick={paramsActive}
                        className={
                          param ? "navListItem currentSelected" : "navListItem"
                        }
                        to="parameter"
                        offset={offset}
                        smooth={true}
                        duration={0}
                      >
                        Test Parameters
                      </Link>
                    ) : null}
                  </li>
                  {QNA && QNA.length && QNA.length !== 0 ? (
                    <li className="navListItem">
                      <Link
                        onClick={setQna}
                        className={
                          QNAactive
                            ? "navListItem currentSelected "
                            : "navListItem"
                        }
                        to="QNA"
                        offset={offset}
                        smooth={true}
                        duration={0}
                      >
                        Q&A
                      </Link>
                    </li>
                  ) : null}
                </div>
              </ul>
              <div id="introduction" className="introduction">
                <div className="lowerChild ">
                  {Centeraddress?.center_address?.address ? (
                    <p>
                      <span className="secHead" style={{ color: "#b5b2b2" }}>
                        {" "}
                        Centre Details:{" "}
                      </span>
                      <span
                        onClick={() => {
                          // console.log(Centeraddress,"centre")
                          handleCentreNameClick(
                            Centeraddress?.center_address?.slug,
                            Centeraddress?.center_address?.city.toLowerCase()
                          );
                        }}
                        className="cardInfo_mainHeading"
                      >
                        {" "}
                        {Centeraddress?.center_address?.address}
                      </span>
                    </p>
                  ) : null}
                  {/* ************** CARDS INFO HERE Comment  ***************/}
                  <div className="Newinfo_card newinfo_card2">
                    {
                      <div className="infocards infocards2">
                        <div className="card_infoIMG card_infoIMG1">
                          <img
                            src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/d4af6e2d-7e56-49ef-8b30-3dca6bfc175c.svg"
                            alt={homeCar}
                            width="100"
                          />
                        </div>
                        <div className="Newinfo_cardContent">
                          <span className="cardInfo_mainHeading cardInfo_mainHeading2">
                            Lady Technician
                          </span>
                          <span className="cardInfo_redHeading cardInfo_redHeading2">
                            Available
                          </span>
                        </div>
                      </div>
                    }

                    {
                      <div className="infocards infocards1 infocards2">
                        <div className="card_infoIMG card_infoIMG1">
                          <img
                            src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/7bfe3e30-2046-440b-bf04-e17f0aa3c87e.svg"
                            alt={folder}
                            width="100"
                          />
                        </div>
                        <div className="Newinfo_cardContent">
                          <span className="cardInfo_mainHeading cardInfo_mainHeading2">
                            Parking facility
                          </span>
                          <span className="cardInfo_redHeading cardInfo_redHeading2">
                            Available
                          </span>
                        </div>
                      </div>
                    }

                    {
                      <div className="infocards infocards1 infocards2">
                        <div className="card_infoIMG card_infoIMG1">
                          <img
                            src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/afa165a6-47e5-424b-97ac-7cf9359b3b87.svg"
                            alt={fasting}
                            width="100"
                          />
                        </div>
                        <div className="Newinfo_cardContent">
                          <span className="cardInfo_mainHeading cardInfo_mainHeading2">
                            100 % Covid Safe
                          </span>
                          {/* ************** comment <span className="cardInfo_redHeading cardInfo_redHeading2">
                            {packageDetails.fasting_time}
                          </span> * **************/}
                        </div>
                      </div>
                    }

                    {/* ************** comment {packageDetails.recommended_age &&
                    packageDetails.recommended_age !== "" ? (
                      <div className="infocards">
                        <div className="card_infoIMG">
                          <img src={watch} alt={watch} width="100" />
                        </div>
                        <div className="Newinfo_cardContent">
                          <span className="cardInfo_mainHeading1">
                            Age Group
                          </span>
                          <span className="cardInfo_redHeading">
                            {packageDetails.recommended_age} years
                          </span>
                        </div>
                      </div>
                    ) : null} * **************/}

                    {/* ************** comment {packageDetails.specimen_instructions &&
                    packageDetails.specimen_instructions !== "" ? (
                      <div className="infocards">
                        <div className="card_infoIMG">
                          <img src={testTube} alt={testTube} width="100" />
                        </div>
                        <div className="Newinfo_cardContent">
                          <span className="cardInfo_mainHeading1">
                            Sample Information
                          </span>
                          <span className="cardInfo_redHeading">
                            {packageDetails.specimen_instructions}
                          </span>
                        </div>
                      </div>
                    ) : null} * **************/}
                  </div>
                </div>

                {/** ************** comment WARNING AND NO WARNING DIV  ***************/}
                {/* ************** comment {packageDetails.fasting_time &&
                packageDetails.fasting_time !== "" ? (
                  <div className="parentWarDiv">
                    <div className="warning">
                      <AiFillInfoCircle />

                      <span>{packageDetails.fasting_time}</span>
                    </div>
                  </div>
                ) : null} * **************/}
                <Warning desc="Physical visit to the centre required" />
                {/************* comment <Regards /> **************/}
                <br />
                <div className="scrollSticky">
                  {packageDetails.description !== "" &&
                    packageDetails.description !== null && (
                      <div className="lowerChild" id="details">
                        <h2 className="subHeading_planDetail subHeading_planDetail2">
                          Test Details
                        </h2>
                        <p>{packageDetails.description}</p>
                      </div>
                    )}

                  {/** ************** comment ACCORDION TEST ***************/}

                  {QNA && QNA.length && QNA.length !== 0 ? (
                    <div
                      className="accordionDiv_pacakgeDetail accordionDiv_pacakgeDetail2"
                      id="criteria"
                    >
                      <h2 className="subHeading_planDetail subHeading_planDetail2">
                        Test Criteria
                      </h2>
                      {QNA &&
                        QNA.map((allData, index) => {
                          return (
                            <ImagingDetailAccordion
                              key={index}
                              data={allData}
                            />
                          );
                        })}
                    </div>
                  ) : null}

                  {/** comment TEST PARAMETERS ACCORDION  */}
                  {testPara.length >= 1 && (
                    <div
                      className="accordionDiv_pacakgeDetail accordionDiv_pacakgeDetail2"
                      id="parameter"
                    >
                      <h2 className="subHeading_planDetail subHeading_planDetail2">
                        Test Parameters
                      </h2>

                      {testPara &&
                        testPara.map((allData, index) => {
                          return <TestParameter key={index} data={allData} />;
                        })}
                    </div>
                  )}

                  {btmQna && (
                    <div className="lowerSection" id="QNA">
                      <div className="testQuestionAnswers">
                        <h2 className="subHeading_planDetail subHeading_planDetail2">
                          Questions & Answers
                        </h2>
                        <div className="testQuestionAnswers_row">
                          {btmQna &&
                            btmQna.map((values, index) => {
                              return (
                                <div className="question_content" key={index}>
                                  <span className="cardInfo_mainHeading">
                                    {values.question}
                                  </span>

                                  <p>{values.answer}</p>
                                </div>
                              );
                            })}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="rightside_section">
              <BookForm
                empty={true}
                packageDetails={packageDetails}
                details=""
                isImagine={true}
              />
            </div>
          </div>
        </div>
        <div className="floatingBooking">
          <div className="border-book">
            <div className="price">
              <span
                style={{
                  textDecoration: "line-through",
                  color: "gray",
                  fontSize: "1.3rem",
                }}
              >
                Rs. {Mrp}/-
              </span>{" "}
              <span className="PriceColor">
                Rs. {offerPrice < 99 ? offerPrice + 200 : offerPrice}/-
              </span>
            </div>
            <div className="discount">
              <span>Get {discountPercentage}% OFF</span>
            </div>
            <div className="New_bookNow">
              <span onClick={() => addtocart(packageDetails.id)}>
                {cartButton}
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ImagingPlanComponent;
